module.exports = __webpack_public_path__ + "img/ape-constructor-cross.d73ae8c8.svg";